/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import classnames from 'classnames';

import './customToolbarItem.scss';

class CustomToolbarItem extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.hidden) {
			return null;
		}

		const classes = classnames({
			'explore-vis-toolbar__full-item': true,
			'explore-vis-toolbar__full-item--enabled': this.isEnabled()
		});
		/* use ariaLabel in props if it is defined. Otherwise use title
+		when both of them are falsy, react is smart enough not to render an undefined attribute */
		const ariaLabel = this.props.ariaLabel || this.props.title;
		const id = this.props.id;

		return (
			<div
				className={classes}
				aria-label={ariaLabel}
				data-id={id}
			>
				{this.props.children}
			</div>
		);
	}

	isEnabled() {
		return this.props.enabled;
	}

}

CustomToolbarItem.propTypes = {
	children: PropTypes.any,
	hidden: PropTypes.bool,
	enabled: PropTypes.bool,
	ariaLabel: PropTypes.string,
	title: PropTypes.string,
	id: PropTypes.string
};

CustomToolbarItem.defaultProps = {
	children: [],
	hidden: false,
	enabled: true
};

export default CustomToolbarItem;



// WEBPACK FOOTER //
// ./src/js/components/toolbar/items/CustomToolbarItem.js